import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import { i18n } from './i18n';
import { useAppStore } from '@/store';

import Toast from 'vue-toastification';
import { useToast } from 'vue-toastification';
// import { useImage } from './helpers/image'
import 'vue-toastification/dist/index.css';
import '@vueform/multiselect/themes/default.css';
import './style.css';
import App from './App.vue';
import SubmitBtn from './components/SubmitBtn.vue';
import IconSpinner from './components/icons/IconSpinner.vue';

const toast = useToast();
const toastOptions = {
  // position: "bottom-right",
  position: 'top-right',
  pauseOnHover: false,
  timeout: 4000,
  maxToasts: 10,
  pauseOnFocusLoss: false,
};

i18n.global.locale.value = localStorage.getItem('lang') || 'tk';

const pinia = createPinia();
// 🟢 Включаем verbose-режим для всех Pinia-экшенов (только в разработке)
if (import.meta.env.DEV) {
  pinia.use(({ store }) => {
    store.$onAction(({ name, args, after, onError }) => {
      console.log(`🟢 [Pinia] Action: ${name}`, args);
      after(result => {
        console.log(`✅ [Pinia] Action ${name} completed`, result);
      });
      onError(err => {
        console.error(`❌ [Pinia] Error in action ${name}`, err);
      });
    });
  });
}

const app = createApp(App);
// Глобальный обработчик ошибок
app.config.errorHandler = (err, vm, info) => {
  console.error('🔴 Vue error:', err); // Логируем ошибку
  console.warn('🔸 In component:', vm); // Компонент, где произошла ошибка
  console.warn('🔹 Additional info:', info); // Дополнительная информация
};
app.use(router);
app.use(pinia);
app.use(i18n);
app.use(Toast, toastOptions);
app.component('SubmitBtn', SubmitBtn);
app.component('IconSpinner', IconSpinner);
app.mount('#app');

const store = useAppStore();
app.config.globalProperties.$store = store;
app.config.globalProperties.$toast = useToast();
